module.exports = __webpack_public_path__ + "static/media/1014991.ab5361b7.jpg";